import { StyledSuggestions, StyledSuggestionsWrapper, StyledTextField } from './styles';

import { Box, CircularProgress, IconButton, InputAdornment, MenuItem, Typography } from '@mui/material';
import PlacesAutocomplete from 'react-places-autocomplete';
import { InitialAddress, useAddressAutocomplete } from './hooks/useAddressAutocomplete';
import styled from 'styled-components';
import { LocationDetails } from '@alluradirect/react';
import CloseIcon from '@mui/icons-material/Close';

const StyledMenuItem = styled(MenuItem)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const searchOptions = {
  types: ['address'],
};

export interface AddressAutocompleteProps {
  formikPrefix: string;
  locationDetails?: LocationDetails;
  initialAddress?: InitialAddress;
  isDisabled?: boolean;
}

/** Please import the FormikAddressAutocomplete component instead of this one to ensure it doesn't break during SSR */
const AddressAutocomplete = ({ formikPrefix = '', locationDetails, initialAddress, isDisabled = false }: AddressAutocompleteProps) => {
  const addressPrefix = `${formikPrefix}ADDRESS.`;

  const { address, setAddress, handleSelectAddress } = useAddressAutocomplete(
    addressPrefix,
    locationDetails,
    initialAddress,
  );

  return (
    <>
      {isDisabled ? <></> :
        <PlacesAutocomplete
          data-testid="placesAutocomplete"
          value={address}
          onChange={setAddress}
          onSelect={handleSelectAddress}
          searchOptions={searchOptions}
          shouldFetchSuggestions={!isDisabled}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
            return (
              <StyledSuggestionsWrapper item xs={12}>
                <StyledTextField
                  {...(getInputProps({
                    label: 'Start by typing your address...',
                  }) as any)}
                  variant="outlined"
                  fullWidth
                  autoComplete="new-password"
                  id="placesAutocomplete"
                  name={`${addressPrefix}CITY`}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setAddress('')}>
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <StyledSuggestions>
                  {loading ? (
                    <Box sx={{ ml: 1 }}>
                      <Box display="flex" alignItems={'center'} sx={{ p: 1 }}>
                        <Typography variant="caption">Loading Results...</Typography>
                        <CircularProgress sx={{ ml: 1 }} size={16} color="secondary" thickness={1} />
                      </Box>
                    </Box>
                  ) : null}
                  {!loading &&
                    suggestions.map(suggestion => {
                      return (
                        <div {...getSuggestionItemProps(suggestion)} key={suggestion.placeId} id={suggestion.placeId}>
                          <StyledMenuItem>{suggestion.description}</StyledMenuItem>
                        </div>
                      );
                    })}
                </StyledSuggestions>
              </StyledSuggestionsWrapper>
            );
          }}
        </PlacesAutocomplete>
      }
    </>
  );
};

export default AddressAutocomplete;
